import React from "react";
import { MdDeleteOutline } from "react-icons/md";

export default function ConfirmModal({
  open,
  title = "Are you sure?",
  message = "You are about to delete this item. This action cannot be undone.",
  confirmText = "Delete",
  cancelText = "Cancel",
  loading = false,
  icon: Icon = MdDeleteOutline,
  iconBgClass = "bg-red-50 text-red-500",
  confirmBtnBg = "#EF4444",
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <div className="flex flex-col items-center py-2 text-center">
          {/* Centered Circle Icon */}
          <div
            className={`mb-5 flex h-20 w-20 items-center justify-center rounded-full ${iconBgClass}`}
          >
            <Icon size={38} />
          </div>

          {/* Title */}
          <h2 className="logout-confirm-title mb-2 text-xl font-bold text-[#0f172a]">
            {title}
          </h2>

          {/* Message */}
          <p className="logout-confirm-desc mb-8 text-sm text-[#64748b]">
            {message}
          </p>

          {/* Action Buttons */}
          <div className="flex w-full gap-3">
            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              style={{
                borderRadius: "10.7px",
                border: "1.34px solid #E2E8F0",
                background: "#FFFFFF",
                opacity: loading ? 0.6 : 1,
                color: "#1a1a1a",
              }}
              className="w-1/2 py-2.5 text-sm font-semibold transition-colors hover:bg-gray-50 disabled:cursor-not-allowed"
            >
              {cancelText}
            </button>

            <button
              type="button"
              onClick={onConfirm}
              disabled={loading}
              style={{
                borderRadius: "10.7px",
                background: confirmBtnBg,
                opacity: loading ? 0.6 : 1,
                color: "white",
              }}
              className="w-1/2 py-2.5 text-sm font-semibold transition-opacity disabled:cursor-not-allowed"
            >
              {loading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}